// Final HTML errors only: successful routes, aliases and API responses stay untouched.
export function light404Path(raw) {
  if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//')) return null;
  const path = raw.split(/[?#]/, 1)[0];
  if (path.length > 500 || /[\u0000-\u0020\\<>"']/.test(path)) return null;
  if (/^\/(?:api|v1|v2|v1alpha1|console|admin|files|_nuxt|__nuxt_error|__sitemap__|analytics-preferences)(?:\/|$)/.test(path)) return null;
  if (/\.[a-z0-9]{1,12}$/i.test(path)) return null;
  return path;
}

export function shouldLighten404(status, method, type, raw) {
  return Number(status) === 404 && ['GET', 'HEAD'].includes(method) &&
    /text\/html/i.test(String(type)) && light404Path(raw) !== null;
}

// No tag manager, application hydration, goals, advertisements or user/profile APIs.
export function error404Measurement() {
  if (/(?:^|;\s*)uo_analytics_excluded=1(?:;|$)/.test(document.cookie)) {
    window.disableYaCounter42914764 = true;
    return;
  }
  if (window.disableYaCounter42914764) return;
  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments); };
  window.ym.l = Date.now();
  var script = document.createElement('script');
  script.async = true;
  script.src = 'https://mc.yandex.ru/metrika/tag.js';
  document.head.appendChild(script);
  var ref = '';
  try { var source = new URL(document.referrer); ref = source.origin + source.pathname; } catch (_) {}
  window.ym(42914764, 'init', {
    defer: true, clickmap: false, trackLinks: false, webvisor: false,
    accurateTrackBounce: true
  });
  window.ym(42914764, 'hit', location.origin + location.pathname, {
    title: 'Страница не найдена — Умный огород', referer: ref,
    params: { page_type: 'error_404', http_status: 404 }
  });
}

export const error404Script = '(' + error404Measurement.toString() + ')();';

export function renderLight404() {
  // Colors, radii and font stacks follow canonical design-system v1.3.1.
  return `<!doctype html><html lang="ru" data-light404="1"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="robots" content="noindex, follow"><title>Страница не найдена — Умный огород</title><style>
*{box-sizing:border-box}body{margin:0;background:#F8FAFC;color:#1F2937;font:16px/1.5 Inter,Arial,sans-serif}main{max-width:640px;margin:0 auto;padding:48px 24px}a{color:#15803D;text-underline-offset:4px}header a{display:inline-flex;align-items:center;min-height:44px;font-weight:700}.card{margin-top:32px;padding:32px;background:#FFF;border:1px solid #E5E7EB;border-radius:20px}.code{margin:0;color:#6B7280;font-weight:600}h1{font-family:'Plus Jakarta Sans',Inter,Arial,sans-serif;font-size:48px;line-height:52px;font-weight:800;letter-spacing:-.035em;margin:16px 0}p{margin:16px 0}.actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:24px}.actions a{display:inline-flex;justify-content:center;align-items:center;min-height:44px;padding:12px 20px;border-radius:999px;font-weight:600}.primary{background:#15803D;color:#FFF;text-decoration:none}.secondary{color:#1F2937}a:focus-visible{outline:3px solid #22C55E;outline-offset:4px}.primary:hover{box-shadow:0 2px 8px #0002}.secondary:hover{text-decoration-thickness:2px}@media(max-width:600px){main{padding:24px 16px}.card{padding:24px;margin-top:24px}h1{font-size:36px;line-height:40px}.actions{flex-direction:column}.actions a{width:100%}}
</style></head><body><main><header><a href="/">Умный огород</a></header><section class="card" aria-labelledby="error-title"><p class="code">Ошибка 404</p><h1 id="error-title">Страница не найдена</h1><p>Возможно, ссылка устарела или в адресе есть опечатка. Найти растение можно в каталоге.</p><nav class="actions" aria-label="Куда перейти"><a class="primary" href="/catalog">Перейти в каталог</a><a class="secondary" href="/">На главную</a></nav></section></main><script>${error404Script}</script></body></html>`;
}
